// Heroku API END POINT: https://sharbel-backend.herokuapp.com
export const API_ENDPOINT = 'https://api.myticketapp.co';
export const API_SOCKETENDPOINT='https://api.myticketapp.co';
export const MyTicket_PATH="/"
export const MyTicket_USER="My-Ticketuser"
export const MyTicket_TOKEN="My-TicketToken"
export const MyTicket_TYPE="My-TicketType"
export const MyTicket_LANGUAGE="My-TicketLang"
export const MyTicket_RULES="My-TicketRules"

export const MyTicket_USER_Cinema="My-Ticketuser-cinema"
export const MyTicket_TOKEN_Cinema="My-TicketToken-cinema"
export const MyTicket_TYPE_Cinema="My-TicketType-cinema"
export const MyTicket_LANGUAGE_Cinema="My-TicketLang-cinema"

export const MyTicket_USER_Event="My-Ticketuser-event"
export const MyTicket_TOKEN_Event="My-TicketToken-event"
export const MyTicket_TYPE_Event="My-TicketType-event"
export const MyTicket_LANGUAGE_Event="My-TicketLang-event"


